import { Component } from '@angular/core';
import { BasePageComponent } from '@m4u-angular/base/component/BasePageComponent';
import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { DataSourceCustomAction } from '@m4u-angular/base/datalayer/BaseDataSources';
import { DataLoadOptions } from '@m4u-angular/base/datalayer/DataLoadOptions';
import { BaseEntity, BaseState, NotificationTemplate } from '@m4u-angular/base/entities/BaseEntities';
import { NotificationTemplateEndpoint } from '@m4u-angular/core/endpoints/notification-template.endpoint';
import { EnumCRUDActions } from '@m4u-angular/core/framework/sysenums.enum';

@Component({
    providers: ServiceBagServices,
    selector: 'app-notification-template-list',
    templateUrl: './notification-template-list.component.html',
    styleUrls: ['./notification-template-list.component.scss']
})
export class NotificationTemplateListComponent extends BasePageComponent<BaseEntity, BaseState> {

    constructor(A: ServiceBagService,
        private notificationTemplateEndpoint: NotificationTemplateEndpoint) {
        super(A, 'NotificationTemplateListComponent', BaseEntity, BaseState);
    }

    protected override OnInitComponent() {
        this.LoadDataSource();
    }

    // eslint-disable-next-line max-len
    protected override OnExternalEntitySaved(ExternalEntity: BaseEntity, ExternalEntityType: new () => BaseEntity, ExternalEntityAction: EnumCRUDActions) {
        if (ExternalEntityType === NotificationTemplate) this.LoadDataSource();
    }

    LoadDataSource() {
        this.DataSources['NotificationTemplates'] = new DataSourceCustomAction((options: DataLoadOptions) => 
            this.notificationTemplateEndpoint.GetListViews());
    }
}
